import { call, put, takeEvery } from "redux-saga/effects"

import { ALL_MY_TEAM_GET_USERS, GET_SAMPLE_CSV_USERS, MY_TEAM_DELETE_USER, MY_TEAM_GET_USERS, MY_TEAM_ISACTIVE, MY_TEAM_RESEND_VERIFICATION_EMAIL, POST_CSV_USERS } from "./actionTypes"

import { deleteUserFailed, deleteUserSuccessful, getSampleCsvUsersFailed, getSampleCsvUsersSuccess, getUsersMyTeamFailed, getUsersMyTeamSuccessful, isActiveFailed, isActiveSuccess, postCsvUsersFailed, postCsvUsersSuccess } from "./actions"

import { deleteUserFB, getCall, getUsersListFB, postCall } from "../../../helpers/fakebackend_helper"

//restapi end point
import * as constClass from "../../../common/constant/constantURL"

function* getUsersHandler({payload:{customJSON}}) {
    try 
    {
      
      let searchKeyWord = customJSON.searchKeyWord;
      let type=customJSON.type
      var url=constClass.REST_API_GET_ALL_USERS_LIST+`?keyword=${searchKeyWord}`+`&userType=${type}`;
      var responsJSON = yield call(getUsersListFB, url);
      yield put(getUsersMyTeamSuccessful(responsJSON))
    } 
    catch (error) 
    {

    
      yield put(getUsersMyTeamFailed(error))
    }
  }
  //get all company client list
  
function* getAllUsersHandler({payload:{customJSON}}) {
  try 
  {
    
    let searchKeyWord = customJSON.searchKeyWord;
    let type=customJSON.type
    var url=constClass.REST_API_GET_ALL_USERS_LIST+`?keyword=${searchKeyWord}`+`&userType=${type}`+`&includeMe=true`;
    var responsJSON = yield call(getUsersListFB, url);
    yield put(getUsersMyTeamSuccessful(responsJSON))
  } 
  catch (error) 
  {
    yield put(getUsersMyTeamFailed(error))
  }
}

  // get candidate list
function* deleteUserF({payload:{userId}}) {
  try 
  {
    var url=constClass.REST_API_DELETE_USER_DELETE;
    var responsJSON = yield call(deleteUserFB, url+"/"+userId);
    yield put(deleteUserSuccessful(responsJSON.message))
   
  } 
  catch (error) 
  {
    yield put(deleteUserFailed(error))
  }
}

  // change status of user
  function* changeStatus({payload:{data}}) {
    try 
    {
      var url=constClass.REST_API_ISACTIVE+data.userId+"&status="+data.status;
      var responsJSON = yield call(deleteUserFB, url);
      yield put(isActiveSuccess(responsJSON.message))
     
    } 
    catch (error) 
    {
      yield put(isActiveFailed(error))
      console.log("Response :: "+error);
    }
  }

  // change status of user
  function* resendVerificationEmail({payload:{data}}) {
    try 
    {
      var responsJSON = yield call(postCall, constClass.REST_API_RESEND_VERIFICATION_EMAIL, data);
      yield put(isActiveSuccess(responsJSON.status))
    } 
    catch (error) 
    {
      yield put(isActiveFailed(error))
      console.log("Response :: "+error);
    }
  }

  function* getSampleCsvUsersHandler() {
    try 
    {
      var responsJSON = yield call(getCall, constClass.REST_API_GET_USERS_LIST+"/csv/sample");
      yield put(getSampleCsvUsersSuccess(responsJSON))
    } 
    catch (error) 
    {
      yield put(getSampleCsvUsersFailed(error))
      
    }
  }

  function* postCsvUsersHandler(data) {
    try 
    {
      var responsJSON = yield call(postCall, constClass.REST_API_GET_USERS_LIST+"/csv",data.payload);
      yield put(postCsvUsersSuccess(responsJSON))
    } 
    catch (error) 
    {
      yield put(postCsvUsersFailed(error))
      
    }
  }



  function* getUsersSaga() {
    yield takeEvery (MY_TEAM_GET_USERS, getUsersHandler);
    yield takeEvery (MY_TEAM_DELETE_USER, deleteUserF);
    yield takeEvery (ALL_MY_TEAM_GET_USERS, getAllUsersHandler);
    yield takeEvery (MY_TEAM_ISACTIVE, changeStatus);
    yield takeEvery (MY_TEAM_RESEND_VERIFICATION_EMAIL, resendVerificationEmail);
    yield takeEvery(GET_SAMPLE_CSV_USERS,getSampleCsvUsersHandler)
    yield takeEvery(POST_CSV_USERS,postCsvUsersHandler)
  }
  
  export default getUsersSaga